const googleAddressApikey = "AIzaSyCYb4ZrW-tE-JlKVoE84r0606U9zS2gcmA";

export default googleAddressApikey;
